<template>
  <div class="" v-for="(item, index) in CONTENTS" :key="index">
    <div class="has-background-white-transparent is-hidden-mobile w-60">
      <div class="content p-6">
        <span class="tag is-black">{{item.caption}}</span>
        <p class="title is-5 my-4">{{item.title}}</p>
        <p class="is-size-6 lh-6" v-html="item.text"></p>
        <p><a class="has-text-theme-black has-text-weight-bold" href="https://www.higashino.co.jp/lp/pdf/catalog.pdf" target="_blank" rel="noopener noreferrer">IKONIHカタログはこちら</a></p>
      </div>
    </div>
    <div class="has-background-white-transparent is-hidden-tablet w-100">
      <div class="content p-6">
        <span class="tag is-black">{{item.caption}}</span>
        <p class="title is-5 my-3">{{item.title}}</p>
        <p class="is-size-6 lh-5" v-html="item.text"></p>
        <p><a class="has-text-theme-black has-text-weight-bold" href="https://www.higashino.co.jp/lp/pdf/catalog.pdf" target="_blank" rel="noopener noreferrer">IKONIHカタログはこちら</a></p>
      </div>
    </div>
  </div>
</template>

<script>
//import config from './../config.json';

const CONTENTS = [
  {
    "caption": "セミオーダーブランド",
    "title": "IKONIH（アイコニー）とは",
    "text": "ひのきの良さを最大限にひきだした『IKONIH』。<br>おもちゃ・家具を通じて木のぬくもりを感じ、自然・モノ・人を大切にする木心を学んで欲しい。そんな想いをのせた特別なブランドです。大阪府内産木材・国産ヒノキで作るおもちゃ・家具を子育て施設さまにご提供しています。",
  }
];

export default {
  name: 'parts-about-semi-order-brand',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    CONTENTS() {
      return CONTENTS;
    }
  }
}
</script>

<style scoped>
.has-background-white-transparent {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>
